import React from 'react';
import dompurify from 'dompurify';

const sanitizer = dompurify.sanitize;

export const renderHtml = (text, className) => {
  if (!text) {
    return null;
  }
  const sanitizedText = sanitizer(text);
  return (<span className={className || ''} dangerouslySetInnerHTML={{ __html: sanitizedText }} />);
};
